export default {
  getReceiving: '/v3/recruit/equipment/payment/detail',
  submitReceive: '/v3/recruit/equipment/receive/affirm'
}
